module.exports = angular.module('cartographer.plugin.layer.fht', [])

_ = require 'underscore'

module.exports.run $DI (crtLayer, fhtPondCountLayer, fhtPriorityPondsLayer) ->
  crtLayer.registerPlugin(fhtPondCountLayer)
  crtLayer.registerPlugin(fhtPriorityPondsLayer)
  return

module.exports.factory "fhtPondCountLayer", $DI (
  crtMarkerColor
  crtFeatureLayer
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
) ->
  crtFeatureLayer.create({
    id: "FhtPondCount"
    name: "England Pond Count"
    atlasMapId: "FhtPondCount"
    defaultMapEngine: "atlas"
    selectionRadius: 500
    attributeGroups: [
      # ...
    ]
  })

module.exports.factory "fhtPriorityPondsLayer", $DI (
  crtMarkerColor
  crtFeatureLayer
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
) ->
  crtFeatureLayer.create({
    id: "FhtPriorityPonds"
    name: "Priority Ponds"
    atlasMapId: "FhtPriorityPonds"
    defaultMapEngine: "atlas"
    selectionRadius: 500
    attributeGroups: [
      # ...
    ]
  })

